import Vue from "vue";

const context = require.context("./", false, /^(?!.*index).+\.js$/);

context.keys().forEach((key) => {
  const directive = context(key).default;
  const name = key.replace("./", "").replace(".js", "");
  Vue.directive(name, directive);
});
